import React from 'react'

function Announcement() {
  return (
    <div className='announce'>
      <h4>Free shipping on orders over 100 Eur!</h4>
      <p> SURPRICE DISCOUNT REVEALED AT CHECKOUT 
      with code: MYSTERY</p>
    </div>
  )
}

export default Announcement
